<div class="arrow-container">
    <div class="block">
        @if (paramToken) {
            <div>
                <h1>Inloggen met link</h1>
                <h2>Klik op de knop hieronder hieronder om automatisch ingelogd te worden.</h2>
                <hr>
                <button mat-flat-button
                        color="accent"
                        class="large"
                        [class.loading]="loginFormState === LoginFormState.Login"
                        (click)="loginParamToken()">Inloggen als {{tokenData?.name}}
                </button>
            </div>
        }

        @if (!paramToken) {
            <form [formGroup]="loginForm" [style.font-size.px]="19">
                <h1 class="mb-0">{{loginFormState === LoginFormState.Send ? 'Gelukt!' : 'Inloggen'}}</h1>

                @if (loginFormState !== LoginFormState.Send && loginFormState !== LoginFormState.ValidatingPin) {
                    <div class="mb-4">
                        We sturen een code naar je e-mailadres.
                    </div>
                    <mat-form-field id="email" color="accent">
                        <input formControlName="email"
                               matInput
                               name="email"
                               placeholder="Vul hier je e-mailadres in"
                               type="text">
                        <mat-label>E-mailadres</mat-label>
                        <mat-error [control]="loginForm.get('email')"></mat-error>
                    </mat-form-field>
                }
                <div>
                    @if (loginFormState !== LoginFormState.Send && loginFormState !== LoginFormState.ValidatingPin) {
                        <button (click)="login()"
                                [disabled]="loginFormState === LoginFormState.Login"
                                [class.loading]="loginFormState === LoginFormState.Login"
                                class="large"
                                color="accent"
                                mat-flat-button>
                            @if (loginFormState !== LoginFormState.Login) {
                                E-mail versturen

                            }
                            @if (loginFormState === LoginFormState.Login) {
                                We versturen je e-mail
                            }
                        </button>
                    }

                    @if ((loginFormState === LoginFormState.Send || loginFormState === LoginFormState.ValidatingPin)) {
                        <mat-form-field id="code" color="accent">
                            <input formControlName="code"
                                   matInput
                                   (keyup.enter)="validateCode()"
                                   (paste)="pasteCode($event)"
                                   name="code"
                                   appDecimalInput
                                   [decimalInput]="0"
                                   autocomplete="one-time-code"
                                   maxlength="6"
                                   placeholder="Vul hier je code in"
                                   type="text">
                            <mat-label>Code</mat-label>
                            <mat-error [control]="loginForm.get('code')"></mat-error>
                        </mat-form-field>


                        <div class="d-flex gap-2">
                            <button (click)="validateCode()"
                                    [disabled]="loginFormState !== LoginFormState.Send"
                                    class="large"
                                    color="accent"
                                    id="btn-code"
                                    mat-flat-button>
                                @if (loginFormState === LoginFormState.Send) {
                                    Bevestigen
                                }
                                @if (loginFormState === LoginFormState.ValidatingPin) {
                                    We controleren je code
                                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                                }
                            </button>
                            <button [disabled]="loginFormState !== LoginFormState.Send"
                                    (click)="loginFormState = LoginFormState.FillIn"
                                    class="large"
                                    color="primary"
                                    mat-flat-button>
                                Opnieuw inloggen
                            </button>
                        </div>
                    }

                    @if (loginFormState === LoginFormState.Send) {
                        <div class="send mb-3 mt-3">
                            <div class="mb-2">
                                @if (isIos) {
                                    <h2>
                                        We hebben een e-mail verzonden naar {{loginForm.get('email').value}}.
                                    </h2>
                                    <h2>
                                        Voer de code uit deze e-mail hierboven in.
                                    </h2>
                                } @else {
                                    <h2>We hebben een link verzonden waarmee je kunt inloggen.</h2>
                                    <h2>Of voer de code uit deze e-mail hierboven in.</h2>
                                }
                            </div>
                            <hr>
                            <small>
                                Controleer of deze in spam terecht is gekomen en voeg
                                <a href="mailto:app@tsned.nl">app&#64;tsned.nl</a> toe aan de lijst met veilige afzenders.
                            </small>
                        </div>
                    }
                </div>
            </form>
        }
    </div>
</div>
